import type { MyBet } from '@swf/generated/types/api/sports';

import type { MyBets, MyBetsState } from '../../types/myBets';

const betsLoadedSuccessfully = (state: MyBetsState, payload: MyBets): MyBetsState => {
  if (state.isSettled !== payload.isSettled) {
    return state;
  }

  const filteredBets = [...state.bets, ...payload.bets].filter(
    (bet) => !!bet.isSettled === !!state.isSettled
  );

  const uniqueBetIds = [...new Set(filteredBets.map((bet) => bet.betId))];

  const uniqueBets = uniqueBetIds.map((id) =>
    filteredBets.find((bet) => bet.betId === id)
  ) as MyBet[];

  return {
    ...state,
    isFetching: false,
    bets: uniqueBets,
    recentlyLoadedBets: payload.bets,
    cashoutQuotes: { ...state.cashoutQuotes, ...payload.cashoutQuotes },
    moreAvailable: payload.moreAvailable,
    numberOfMatches: payload.numberOfMatches
  };
};

export default betsLoadedSuccessfully;
